import Button from "components/Button";
import KnowledgeBaseCallout from "components/KnowledgeBaseCallout";
import PageHeader from "components/PageHeader";
import { quotePathById } from "helpers/me-home";

import {
  QUOTE_STAGE_BODY,
  quoteStageTitle,
  type PolicyView,
} from "./policy-view";

/** The top of a policy whose quote is still active: who the family is
 * planning for, the way back to the quote, and the answers. */
export default function PolicyQuoteLanding({
  view,
  policyId,
  quoteId,
}: {
  view: PolicyView;
  policyId: string;
  quoteId: string;
}) {
  return (
    <div className="flex flex-col gap-2">
      <PageHeader
        eyebrow="Pre-planning"
        title={quoteStageTitle(view)}
        description={QUOTE_STAGE_BODY}
      />
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <Button href={quotePathById(quoteId)} variant="compact">
          View your quote
        </Button>
      </div>
      <KnowledgeBaseCallout
        subject={{ kind: "policy", id: policyId }}
        className="mt-8"
      />
    </div>
  );
}
